import { put } from '../request'

export const updateImplementationItem = (offer, data) => put(`api/implementation-items/${offer}`, data)
export const updateImplementation = (id, data) => put(`api/implementations/${id}`, data)
